import React from 'react'
import { number, string } from 'prop-types'
import { css } from '@emotion/react'

const ratesSummaryTextCss = css`
  display: flex;
  align-items: flex-end;
  flex-shrink: 0;
  margin: 0;
  height: 56px;
  font-size: 12px;
  font-weight: bold;

  > span:first-of-type {
    font-size: 56px;
    line-height: 44px;
  }
`

const RatingInfo = ({ votes, rate, className }) => (
  <p css={ratesSummaryTextCss} className={className}>
    <span>{rate}</span>
    <span>
      out of 5 • {votes} {votes === 1 ? 'Rating' : 'Ratings'}
    </span>
  </p>
)

RatingInfo.propTypes = {
  votes: number,
  rate: number,
  className: string,
}

export default RatingInfo
